/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionEntryType } from './CompetitionEntryType';
import {
    CompetitionEntryTypeFromJSON,
    CompetitionEntryTypeFromJSONTyped,
    CompetitionEntryTypeToJSON,
    CompetitionEntryTypeToJSONTyped,
} from './CompetitionEntryType';

/**
 * Real-time prize pool status for a leaderboard competition
 * @export
 * @interface LeaderboardPrizePoolStatus
 */
export interface LeaderboardPrizePoolStatus {
    /**
     * The leaderboard ID
     * @type {string}
     * @memberof LeaderboardPrizePoolStatus
     */
    leaderboardId?: string;
    /**
     * Human-readable leaderboard name
     * @type {string}
     * @memberof LeaderboardPrizePoolStatus
     */
    leaderboardName?: string;
    /**
     * Total amount in escrow (in smallest currency unit - cents for USD, base units for FUEL)
     * @type {number}
     * @memberof LeaderboardPrizePoolStatus
     */
    currentPool?: number;
    /**
     * Number of paid entries so far
     * @type {number}
     * @memberof LeaderboardPrizePoolStatus
     */
    entryCount?: number;
    /**
     * Entry fee per participant (in smallest currency unit)
     * @type {number}
     * @memberof LeaderboardPrizePoolStatus
     */
    entryFee?: number;
    /**
     * Currency of the prize pool
     * @type {string}
     * @memberof LeaderboardPrizePoolStatus
     */
    currency?: LeaderboardPrizePoolStatusCurrencyEnum;
    /**
     * Platform fee percentage (0-100)
     * @type {number}
     * @memberof LeaderboardPrizePoolStatus
     */
    platformFeePercent?: number;
    /**
     * Amount available for winners. Entry fees after the platform fee, or the Devour-committed guarantee when that is higher — the guarantee is a floor, never added on top. USD-priced boards only for the guarantee half; a FUEL-priced board converts its commitment at payout time, so this stays in FUEL there.
     * @type {number}
     * @memberof LeaderboardPrizePoolStatus
     */
    winnerPool?: number;
    /**
     * Calculated platform fee amount
     * @type {number}
     * @memberof LeaderboardPrizePoolStatus
     */
    platformFee?: number;
    /**
     * The Devour-committed minimum in USD dollars, when this board has one. Reported separately from winnerPool because the two are not always the same unit.
     * @type {number}
     * @memberof LeaderboardPrizePoolStatus
     */
    guaranteedPoolUsd?: number;
    /**
     * Current escrow status (PENDING, PARTIAL, LOCKED, etc.)
     * @type {string}
     * @memberof LeaderboardPrizePoolStatus
     */
    status?: string;
    /**
     * 
     * @type {CompetitionEntryType}
     * @memberof LeaderboardPrizePoolStatus
     */
    entryType?: CompetitionEntryType;
    /**
     * Whether this leaderboard requires an entry fee
     * @type {boolean}
     * @memberof LeaderboardPrizePoolStatus
     */
    hasEntryFee?: boolean;
}


/**
 * @export
 */
export const LeaderboardPrizePoolStatusCurrencyEnum = {
    FUEL: 'FUEL',
    USD: 'USD'
} as const;
export type LeaderboardPrizePoolStatusCurrencyEnum = typeof LeaderboardPrizePoolStatusCurrencyEnum[keyof typeof LeaderboardPrizePoolStatusCurrencyEnum];


/**
 * Check if a given object implements the LeaderboardPrizePoolStatus interface.
 */
export function instanceOfLeaderboardPrizePoolStatus(value: object): value is LeaderboardPrizePoolStatus {
    return true;
}

export function LeaderboardPrizePoolStatusFromJSON(json: any): LeaderboardPrizePoolStatus {
    return LeaderboardPrizePoolStatusFromJSONTyped(json, false);
}

export function LeaderboardPrizePoolStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardPrizePoolStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'leaderboardId': json['leaderboardId'] == null ? undefined : json['leaderboardId'],
        'leaderboardName': json['leaderboardName'] == null ? undefined : json['leaderboardName'],
        'currentPool': json['currentPool'] == null ? undefined : json['currentPool'],
        'entryCount': json['entryCount'] == null ? undefined : json['entryCount'],
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'platformFeePercent': json['platformFeePercent'] == null ? undefined : json['platformFeePercent'],
        'winnerPool': json['winnerPool'] == null ? undefined : json['winnerPool'],
        'platformFee': json['platformFee'] == null ? undefined : json['platformFee'],
        'guaranteedPoolUsd': json['guaranteedPoolUsd'] == null ? undefined : json['guaranteedPoolUsd'],
        'status': json['status'] == null ? undefined : json['status'],
        'entryType': json['entryType'] == null ? undefined : CompetitionEntryTypeFromJSON(json['entryType']),
        'hasEntryFee': json['hasEntryFee'] == null ? undefined : json['hasEntryFee'],
    };
}

export function LeaderboardPrizePoolStatusToJSON(json: any): LeaderboardPrizePoolStatus {
    return LeaderboardPrizePoolStatusToJSONTyped(json, false);
}

export function LeaderboardPrizePoolStatusToJSONTyped(value?: LeaderboardPrizePoolStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaderboardId': value['leaderboardId'],
        'leaderboardName': value['leaderboardName'],
        'currentPool': value['currentPool'],
        'entryCount': value['entryCount'],
        'entryFee': value['entryFee'],
        'currency': value['currency'],
        'platformFeePercent': value['platformFeePercent'],
        'winnerPool': value['winnerPool'],
        'platformFee': value['platformFee'],
        'guaranteedPoolUsd': value['guaranteedPoolUsd'],
        'status': value['status'],
        'entryType': CompetitionEntryTypeToJSON(value['entryType']),
        'hasEntryFee': value['hasEntryFee'],
    };
}

